import axios from 'axios';
import Url from '../constants/Url';

class FGOnboardingStatusApi {
    complete(params) {
        return axios
            .post(Url().SET_FG_ONBOARDING_COMPLETE, {params})
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to setOnboardingComplete:', ex.message);
                throw ex;
            });
    }
}

export default new FGOnboardingStatusApi();
